import { render, staticRenderFns } from "./notification-center.vue?vue&type=template&id=26f911c0&scoped=true&lang=pug"
import script from "./notification-center.vue?vue&type=script&lang=js"
export * from "./notification-center.vue?vue&type=script&lang=js"
import style0 from "./notification-center.vue?vue&type=style&index=0&id=26f911c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f911c0",
  null
  
)

export default component.exports